import React from 'react'
import { BeePlugin, ToolBar, ToolBarActions } from './../components'

const BeeEditorWrapper = ({
  id, row, topbar, bottombar, product, template, mode, sessionId
}) => {
  const isCoedit = mode === 'coedit'
  const isConverting = mode === 'convert'

  return (
    <>
      <ToolBarActions
        id={id}
        template={template}
        product={product}
        row={row}
        isCoedit={isCoedit}
        isConverting={isConverting}
        sessionId={sessionId}
      />
      {topbar && <ToolBar type="top" />}
      <BeePlugin
        id={id}
        template={template}
        product={product}
        row={row}
        isCoedit={!!isCoedit}
        sessionId={sessionId}
      />
      {bottombar && <ToolBar type="bottom" />}
    </>
  )
}
export default BeeEditorWrapper
